define('gigaset_contentbridge/classes/utils',[
	"jquery"
], function(
	$
) {
	var $$ = {};

	/**
	 * A utility log function.
	 *
	 */
	$$.log = function(m) {
		if (window && window.console && window.console.log) {
			window.console.log(arguments.length == 1 ? m : arguments);
		}
	};


	/**
	 * The function is indented for submitting a form query on the change event.
	 * It replaces the action attribute of the form with the correct hashed one
	 * stored in a link (<a>-tag) inside a hidden div tag.
	 * It requires the jquery library.
	 * @param elem
	 * @param linkIdPrefix
	 * @param val an optional parameter which can be used to override the value
	 * of the input/select element.
	 */
	$$.submit_query=function(elem,linkIdPrefix,val) {
		var form=$(elem).closest('form');
		val=val || $(elem).val();
		if (val!='') {
			var link=$('#'+linkIdPrefix+val);
			window.location.href =link.attr('href');
		}
	};


	/**
	 * The function is for switching select input elements in the registration
	 * customer care and showing the corresponding registration image.
	 * @param elem the select element that was switched
	 */
	$$.switch_product_types=function(elem) {
		var $elem=$(elem);
		var id=$elem.val();
		if (id) {
			var type=gigaset._product_type[id];
			var otype=gigaset._opposite_of[type];
			var $form=$elem.closest('form');
			var select=$form.attr('name');
			var oselect=gigaset._opposite_of[select];
			var $imgdiv=$('#'+select+'-image-div');
			$("div.giga_product_select").hide();
			var $div=$("#"+select+"-"+type);
			$("select",$div).val(id);
			$div.show();
			$("#"+oselect+"-"+otype).show();
			var img=$('#'+select+'-image');
			img.attr('src',$('#product_'+id).attr('data-imgurl'));
			$('h3',$imgdiv).text($elem.attr('data-no')+$("option:selected",$elem).text());
			$('img',$form).attr('src',$('#product_'+id).attr('data-thumbnail'));
			$imgdiv.show();
		}
	};



	/**
	 * The function creates a product search box with autocompletion.
	 * It requires the jquery-ui library.
	 * @param elem the input element we use
	 * @param products an object with a mapping for all products.
	 * It has to be of the form <code>{ 'product name' : 'product_id',....}</code>
	 * @param linkIdPrefix used for the submit_query call
	 */
	$$.product_search=function(elem,products,linkIdPrefix,appendTo) {
		elem=$(elem);
		var vals=$.map(products,function(val,key){return key;});
		elem.autocomplete({
			"appendTo":appendTo,
			"source":vals,
			"minLength":0,
			"select":function(ev,ui){
				var name=ui.item.value;
				$$.submit_query(elem,linkIdPrefix,products[name]);
			},
			"open":function(){
				$(this).autocomplete('widget').css('z-index',999);
				return false;
			}

		});
		elem.on('dblclick',function(ev){
			elem.autocomplete('search');
		});
	};


	/**
	 * This function redirect the browser to the correct cached url based on the 'product'-parameter
	 */
	$$.redirect_to_product=function(linkIdPrefix) {
		var productId=decodeURI((RegExp('[\?&]product=([^&]+)(&|$)').exec(location.search)||[,null])[1]);
		if (productId) {
			var url=$("#"+linkIdPrefix+productId).attr('href');
			if (url) {
				window.location=url;
			}
		}

	};


	/**
	 * This toggles the visibility of a dependent element by a mouse click.
	 */
	$$.toggle_element=function(trigger,elem) {
		$(trigger).click(function(ev) {
			$(elem,$(ev.currentTarget).parent()).toggle();
		});
	};

	/**
	 * The function is showing the correct compatibility table based on
	 * the second selected product
	 * @param elem the select element that was switched
	 */
	$$.change_compat_product2=function(elem,linkIdPrefix,allElems,imgIdPrefix) {
		var $elem=$(elem);
		var $form=$elem.closest('form');
		var id=$elem.val();
		var $cur;
		$(allElems).hide();
		$('img',$form).attr('src',$('#'+imgIdPrefix+id).attr('data-thumbnail'));
		$cur=$('#'+linkIdPrefix+id);
		$cur.show();
	};

	return $$;
});
